<template>
  <div class="WorkbenchWrap">
    <div class="pageRow">
      <div class="blockWrap realTime ashComWrap">
        <div class="comTitle">
          <h4
            class="titleHover"
            style="cursor: pointer"
            @click="$router.push('/equipmentConsume')"
          >
            实时能耗监控
          </h4>
        </div>
        <div class="comContentBox realTimeContent">
          <div class="formBox">
            <el-radio-group v-model="type" @change="changetype" size="mini">
              <el-radio-button label="分项系统">系统</el-radio-button>
              <el-radio-button label="区域位置">区域</el-radio-button>
              <el-radio-button label="单位部门">部门</el-radio-button>
            </el-radio-group>
            <el-cascader
              style="margin: 0 10px"
              :key="keyValue"
              v-model="defaultKeys"
              :options="dataList"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                value: 'id',
                label: 'name',
                emitPath: false,
              }"
              :clearable="false"
              size="mini"
            ></el-cascader>
            <el-radio-group
              v-model="activeType"
              size="mini"
              style="margin-right: 20px"
              @change="onSubmit"
            >
              <el-radio-button
                v-for="v in energyTypeList"
                :key="v.key"
                :label="v.key"
                >{{ v.name }}</el-radio-button
              >
            </el-radio-group>
            <el-button type="primary" size="mini" @click="onSubmit"
              >查询</el-button
            >
          </div>
          <div class="realTimeBox">
            <div class="chartsBox">
              <PublicEcharts
                id="'myCharts'"
                :chartsData="realTimeData"
                :type="'lineAverage'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="blockWrap ashComWrap">
        <div class="comTitle">
          <h4
            class="titleHover"
            style="cursor: pointer"
            @click="$router.push('/equipmentConsume')"
          >
            本月能耗排名
          </h4>
          <ul class="planUl">
            <li
              v-for="(v, i) in rankingMenu"
              :key="v.key"
              :style="{ color: rankingActive == i ? '#28CCCB' : '#666' }"
              @click="
                rankingActive = i;
                getECRanking();
              "
            >
              {{ v.name }}
            </li>
          </ul>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            id="'ranking'"
            :chartsData="rankingCharts"
            :type="'deepBroadwiseBar'"
          />
        </div>
      </div>
    </div>
    <div class="pageRow">
      <div class="blockWrap monitoring ashComWrap">
        <div class="comTitle">
          <h4
            class="titleHover"
            style="cursor: pointer"
            @click="$router.push('/equipmentStatus')"
          >
            设备监控
          </h4>
          <ul>
            <li>全部 {{ monitoringData?.total }}</li>
            <li>在线 {{ monitoringData?.active }}</li>
            <li>离线 {{ monitoringData?.notActive }}</li>
            <li>报警 {{ monitoringData?.alarmNum }}</li>
          </ul>
        </div>
        <div class="comContentBox monitoringContent">
          <MonitoringCard @getMonitoringData="getMonitoringData" />
        </div>
      </div>
      <div class="blockWrap alarmAndOrder ashComWrap">
        <div class="comTitle">
          <h4
            class="titleHover"
            style="cursor: pointer"
            @click="$router.push('/alarmManagement')"
          >
            今日报警
          </h4>
        </div>
        <div class="comContentBox alarmAndOrderContent">
          <AlarmOrderCom :comType="'alarm'" />
        </div>
      </div>
    </div>
    <div class="pageRow">
      <div class="blockWrap">
        <TodayPlan />
      </div>
      <div class="blockWrap alarmAndOrder ashComWrap">
        <div class="comTitle">
          <h4
            class="titleHover"
            style="cursor: pointer"
            @click="$router.push('/worksheets')"
          >
            今日工单
          </h4>
        </div>
        <div class="comContentBox alarmAndOrderContent">
          <AlarmOrderCom :comType="'order'" />
        </div>
      </div>
    </div>
    <div class="pageRow">
      <div class="orderBox ashComWrap">
        <div class="comTitle">
          <h4>工单流程</h4>
        </div>
        <div class="comContentBox">
          <WorkOrderTable />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import PublicEcharts from "@/components/PublicEcharts.vue";
import AlarmOrderCom from "@/components/gongzuotai/AlarmOrderCom";
import WorkOrderTable from "@/components/gongzuotai/WorkOrderTable";
import MonitoringCard from "@/components/gongzuotai/MonitoringCard";
import TodayPlan from "@/components/gongzuotai/TodayPlan";
import { dateFtt, dealBigNum, handleNumDecimal } from "@/assets/js/utils";
export default {
  components: {
    PublicEcharts,
    AlarmOrderCom,
    WorkOrderTable,
    MonitoringCard,
    TodayPlan,
  },
  data() {
    return {
      type: "分项系统",
      defaultProps: {
        children: "children",
        label: "name",
      },
      dataList: [],
      treeAllData: [], //全部树数据
      defaultKeys: [], //默认选择
      keyValue: 0,
      rankingMenu: [
        { name: "系统", key: "分项系统" },
        { name: "区域", key: "区域位置" },
        { name: "部门", key: "单位部门" },
      ],
      rankingActive: 1,
      realTimeData: {
        unit: "",
        showChange: true,
        xData: [],
        dataArr: [],
      },
      rankingCharts: {
        unit: "kw·h",
        xData: [],
        dataArr: [],
      },
      monitoringData: {},
      energyTypeList: [],
      activeType: "",
    };
  },
  watch: {
    dataList(newVal) {
      this.keyValue++; //只要监听到数据源发生变化 ，改变keyValue的值，达到重新渲染的效果
    },
  },
  methods: {
    dealBigNum,
    getTreeData() {
      this.treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.dataList = [this.treeAllData[this.type]];
      this.$nextTick(() => {
        this.defaultKeys = this.dataList[0].id;
        this.onSubmit();
      });
    },
    changetype() {
      this.dataList = [this.treeAllData[this.type]];
      this.$nextTick(() => {
        this.defaultKeys = this.dataList[0].id;
      });
    },
    async onSubmit() {
      this.realTimeData.xData = [];
      this.realTimeData.unit = this.activeType == "power" ? "kw·h" : "m³";
      this.realTimeData.dataArr = [];
      let res = await api.controlGetECData({
        assetId: this.defaultKeys,
        type: this.activeType == "power" ? "DAY" : "MONTH",
        energyType: this.activeType,
      });
      if (res && res.data.code == 200) {
        let arr = [];
        res.data.data.charts.map((v) => {
          this.realTimeData.xData.push(
            dateFtt(
              this.activeType == "power" ? "hh:mm" : "dd日",
              new Date(v.ts)
            )
          );
          arr.push(v.charts);
        });
        for (let i = 0; i < arr[0].length; i++) {
          this.realTimeData.dataArr.push({ name: "", data: [] });
          arr.forEach((item) => {
            this.realTimeData.dataArr[i].name = item[i].name;
            this.realTimeData.dataArr[i].data.push(
              handleNumDecimal(item[i].value)
            );
          });
        }
      }
    },

    // 设备监控总数
    getMonitoringData(data) {
      this.monitoringData = data;
    },
    async getECRanking() {
      let res = await api.controlGetECRanking({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        label: this.rankingMenu[this.rankingActive].key,
      });
      if (res && res.data.code == 200) {
        this.rankingCharts.xData = [];
        this.rankingCharts.dataArr = [
          { name: "上月", data: [] },
          { name: "本月", data: [] },
        ];
        res.data.data.slice(0, 5).map((v) => {
          this.rankingCharts.xData.push(v.entityName);
          this.rankingCharts.dataArr[0].data.push(v.beforeSumAddition);
          this.rankingCharts.dataArr[1].data.push(v.sumAddition);
        });
      }
    },
  },
  created() {
    this.energyTypeList = JSON.parse(
      window.sessionStorage.getItem("energyType")
    );
    this.activeType = this.energyTypeList[0].key;

    this.getTreeData();
    this.getECRanking();
  },
};
</script>

<style lang="scss" scoped>
.WorkbenchWrap {
  width: $innerWidth;
  margin: 0 auto;
  overflow: auto;
  .pageRow {
    width: 100%;
    height: 400px;
    margin-bottom: 12px;
    @include setFlexBetween;
    .blockWrap {
      width: $halfWidth;
      height: 100%;
      .titleHover:hover {
        color: #28cccb;
      }
    }
    .orderBox {
      width: 100%;
      height: 100%;
    }
  }
  .pageRow:last-child {
    margin-bottom: 16px;
  }
  .pageRow:first-child {
    margin-top: 16px;
  }

  ul {
    margin-right: 10px;
    @include setFlexStart;
    li {
      margin-right: 10px;
    }
  }

  .realTime {
    .realTimeContent {
      .formBox {
        width: 98%;
        height: 50px;
        margin: 0 auto;
        @include setFlexStart;
      }
      .realTimeBox {
        width: 98%;
        height: calc(100% - 50px);
        margin: 0 auto;
        @include setFlexBetween;
        .chartsBox {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
